import { render, staticRenderFns } from "./CreateUpdateAttribute.vue?vue&type=template&id=04a1e528"
import script from "./CreateUpdateAttribute.vue?vue&type=script&lang=js"
export * from "./CreateUpdateAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports